import { render, staticRenderFns } from "./redis.vue?vue&type=template&id=159582c9"
import script from "./redis.vue?vue&type=script&lang=js"
export * from "./redis.vue?vue&type=script&lang=js"
import style0 from "./redis.vue?vue&type=style&index=0&id=159582c9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports